module.exports = __webpack_public_path__ + "static/img/banner.6b4f367f.png";